module.exports = __webpack_public_path__ + "static/media/image_reports_24px_rounded.36a6cab0.svg";